module.exports = __webpack_public_path__ + "static/media/nft_bonus.41328688.png";